import React from 'react'
import { Form } from 'react-bootstrap'

const Feedback = ({
    value = '',
    onChange = () => {}
}) => {

    return (
        <div style={{ padding: '10px 0px'}}>
            <Form.Control
                style={{ minWidth: '300px', maxWidth: '300px' }}
                as="textarea"
                rows={2}
                value={value || ''}
                onChange={e => onChange(e.target.value)}
                placeholder='Optional comments'
            />
        </div>
    )
}

export default Feedback